import React, { PureComponent } from 'react';
import { Image } from 'cloudinary-react';
import cx from 'classnames';
import PlaceholderDark from '../../../../images/placeholder-dark-logo.png';
import PlaceholderLight from '../../../../images/placeholder-light-logo.png';
import * as constants from '../../../../constants';

class CloudinaryThumb extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
    };
    this.renderedImage = React.createRef();
  }

  thumbClickEvent = () => {
    const { id, handleClick } = this.props;
    if (typeof handleClick === 'function') handleClick(id);
  };

  buildThumb = () => {
    const { mediaType, id = '', mediaUrl } = this.props;
    let videos360Id;
    const [str, format] = id.split('.');

    if (mediaType === constants.VIDEOS360) {
      videos360Id = str;
    }
    let assetId = 'images/audio-thumb-placeholder.jpg';
    if (mediaType === constants.ICONS && mediaUrl) assetId = `${mediaUrl}`;
    else if (mediaType !== constants.AUDIO)
      assetId = `${mediaType}/${videos360Id || id}`;
    return {
      assetId,
      format,
    };
  };

  setLoaded = () => {
    this.setState({ loaded: true });
  };

  render() {
    const { loaded } = this.state;
    const {
      alt = '',
      classes,
      deleted,
      dragHandle,
      dragHandleProps,
      height,
      id,
      logo,
      mediaType,
      name,
      noBackground,
      overlayMediaName,
      pad,
      publicId,
      selectedMedia,
      thumbBtns,
      view,
    } = this.props;

    const classNames = cx({
      'thumb-image': true,
      loaded,
      hidden: deleted && !selectedMedia,
      'hidden-width': deleted && id === selectedMedia,
      pano: mediaType === constants.PANOS,
    });
    const backgroundSize = Math.round(height / 2);
    const placeholderImg = view ? PlaceholderLight : PlaceholderDark;
    const defaultColor = view ? '#000' : '#fff';
    const wrapperBackgroundImg =
      !logo &&
      `${defaultColor} url(${placeholderImg}) center / ${backgroundSize}px no-repeat`;
    const { assetId } = this.buildThumb();
    const cropLogo = logo ? 'limit' : pad ? 'pad' : 'lfill';
    const backgroundLogo = logo ? '' : 'black';
    const is360 = mediaType === 'videos360';

    if (!id) {
      return null;
    }

    // conditionally add the `alt` attribute to elements
    // otherwise the image is not able to be reached at all by screen readers if `alt=""`
    if (alt && this.renderedImage.current) {
      this.renderedImage.current.element.current.alt = alt;
    }

    const testId = `cloudinary-thumb-${id}`;
    return (
      <div
        className={cx(`${classes} thumb-wrapper`, {
          loaded,
          'fill-background': loaded && !noBackground,
        })}
        key={id}
        style={{ background: wrapperBackgroundImg }}
        onClick={this.thumbClickEvent}
        onKeyPress={this.thumbClickEvent}
        data-cy={testId}
        data-testid={testId}
      >
        {!is360 && (
          <Image
            alt={alt}
            background={backgroundLogo}
            className={classNames}
            cloudName="concept3d"
            crop={cropLogo}
            fetchFormat="auto"
            gravity="center"
            height={height}
            onLoad={this.setLoaded}
            publicId={publicId || assetId}
            quality="auto"
            ref={this.renderedImage}
          />
        )}
        {is360 && (
          <Image
            alt={alt}
            className={classNames}
            cloudName="concept3d"
            fetchFormat="jpg"
            height={height || 1}
            onLoad={this.setLoaded}
            publicId={assetId}
            quality="auto"
            resourceType="video"
          />
        )}
        {typeof thumbBtns === 'function' && (
          <div className="thumb-btn-wrapper">
            {thumbBtns(id)}
            {typeof dragHandle === 'function' && dragHandle(dragHandleProps)}
          </div>
        )}
        {overlayMediaName && <span className="stop-name overlay">{name}</span>}
      </div>
    );
  }
}

export default CloudinaryThumb;
